import { AxiosError } from 'axios';
import { useQuery } from '@th/react-query';
import logAxiosError from '../../utils/logAxiosError';
import AxiosClient from '../../utils/AxiosClient';

export default function useFetchValuationEstimate(id: string): {
  valuationEstimate: number | null;
  isLoading: boolean;
  isSuccess: boolean;
} {
  const endpoint = `/api/listings/${id}/estimate`;
  const { data, isLoading, isSuccess } = useQuery(
    ['fetchValuationEstimate', id],
    async () => {
      return AxiosClient.get(endpoint);
    },
    {
      refetchOnWindowFocus: false,
      onError: (err: AxiosError) => {
        logAxiosError(`useFetchValuationEstimate GET ${endpoint}`, err);
      },
    },
  );

  const valuationEstimate = data?.data?.valuationEstimate || null;

  return {
    valuationEstimate,
    isLoading,
    isSuccess,
  };
}
